function PC () {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    console.log('您正在是使用手机设备')
  } else {
    document.getElementsByTagName('body')[0].className = 'PC-container'
  }
}
PC()



// WEBPACK FOOTER //
// ./src/assets/PC.js